import React, { useState, useEffect } from "react";
import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client";
import { useFilters } from "../../../../Components/Filters/Filters.hook";
import { encodeHashUrl } from "../../../../Utils/Functions";
import { useRouter } from "next/router";
import { QUERY_AVAILABLE_FILTERS } from "shared-components/GQL";

const QUERY_SEARCH_URL = gql`
	query searchUrl($params: SearchParamsInput!) {
		searchUrl(params: $params) {
			url
		}
	}
`;

const BOOLEAN_PARAM_KEYS = [
	"hasGarage",
	"tour3d",
	"privateOwner",
	"socialHousing",
	"seen",
	"seaview",
	"projects",
];

const normalizeSearchParams = (params: Record<string, unknown>): Record<string, unknown> => {
	if (!params) return params;
	const normalized = { ...params };
	for (const key of BOOLEAN_PARAM_KEYS) {
		if (key in normalized && normalized[key] != null) {
			normalized[key] = Boolean(normalized[key]);
		}
	}
	return normalized;
};

const useSearchResultsFilters = (forceUrlUpdate = true) => {
	const { filters, changeFilters, filtersTags } = useFilters();
	const [updateURL, setUpdateURL] = useState(true);
	const router = useRouter();

	useEffect(() => {
		const handlePopstate = () => {
			window.location.reload();
		};
		window.addEventListener("popstate", handlePopstate);

		return () => {
			window.removeEventListener("popstate", handlePopstate);
		};
	}, []);

	useQuery(QUERY_SEARCH_URL, {
		variables: {
			params: normalizeSearchParams((filters ?? {}) as Record<string, unknown>),
		},
		skip: !updateURL && !forceUrlUpdate,
		onCompleted: dataURL => {
			if (typeof window !== "undefined" && window.history && updateURL) {
				router.push(
					{
						pathname: "/searchPage",
						query: { hashed: encodeHashUrl({ filters: filtersTags }) },
					},
					dataURL.searchUrl.url
				);
			}
		},
	});

	const changeFiltersAndUpdateURL = new_filters => {
		if (!updateURL) setUpdateURL(true);
		changeFilters(new_filters);
	};

	const { data, loading, error } = useQuery(QUERY_AVAILABLE_FILTERS);

	return {
		data,
		loading,
		error,
		changeFiltersAndUpdateURL,
	};
};

export { useSearchResultsFilters };
